module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col\">\n      <p>URGENCIAS</p>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/tretapey/Documents/Programmer/craCSS/DOC-in/src/app/home/urgencias/urgencias.component.html
// module id = ../../../../../src/app/home/urgencias/urgencias.component.html
// module chunks = 1